
<div class="modal-body">
  <div class="form-group">
    <label translate>Path</label>
    <input class="form-control" disabled type="text" [(ngModel)]="paths[0]" id="backupAddDirModal-path" [srLabel]="&quot;Path&quot;|translate">
  </div>
  <div class="form-group">
    <label translate>Add files</label>
    <div>
      <button class="btn btn-secondary" (click)="add('all')"><i class="far fa-plus"></i><span translate>All files</span></button>
    </div>
    <div>
      <button class="btn btn-secondary" (click)="add('not-archived')"><i class="far fa-plus"></i><span translate>Not archived</span></button>
    </div>
    <div>
      <button class="btn btn-secondary" (click)="add('archived-once')"><i class="far fa-plus"></i><span translate>Archived only once or not at all</span></button>
    </div>
    <div class="input-group">
      <div class="input-group-prepend">
        <button class="btn btn-secondary" (click)="add('not-in-group', { group_name: tapegroup.name, group_id: tapegroup.id })"><i class="far fa-plus"></i><span translate>Not archived on</span></button>
      </div>
      <select class="form-control" [(ngModel)]="tapegroup">
        <option *ngFor="let x of tapegroups" [ngValue]="x">{{x.name}}</option>
      </select>
    </div>
  </div>
</div>
<div class="modal-footer">
  <button class="btn btn-outline-secondary" (click)="cancel()"><span translate>Cancel</span></button>
</div>